import { render, staticRenderFns } from "./cont_four.vue?vue&type=template&id=4cbc6874&scoped=true"
import script from "./cont_four.vue?vue&type=script&lang=js"
export * from "./cont_four.vue?vue&type=script&lang=js"
import style0 from "./cont_four.vue?vue&type=style&index=0&id=4cbc6874&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc6874",
  null
  
)

export default component.exports